import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { DRAFT_API } from '../lib/emailDrafts';

export const useEmailLimits = (password) => {
  const [limits, setLimits] = useState(null), [error, setError] = useState(''), [loading, setLoading] = useState(false);
  const pending = useRef(null);
  const load = useCallback(async () => {
    if (!password) return;
    pending.current?.abort();
    const controller = new AbortController(); pending.current = controller;
    setLoading(true); setError('');
    try {
      const { data } = await axios.get(`${DRAFT_API}/limits`, { headers: { Authorization: `Basic ${btoa(':' + password)}` }, signal: controller.signal, timeout: 15000 });
      if (!(data.max_attachment_bytes > 0 && data.max_upload_files > 0 && data.bytes_per_mb === 1000000)) throw new Error('Invalid attachment limits');
      setLimits(data);
    } catch { if (!controller.signal.aborted) setError('Attachment limits could not be loaded. Retry before saving or sending.'); }
    finally { if (!controller.signal.aborted) setLoading(false); }
  }, [password]);
  useEffect(() => { load(); return () => pending.current?.abort(); }, [load]);
  return { limits, error, loading, retry: load };
};